import { useTheme } from "../../context/ThemeContext";
import { Sun, Moon } from "lucide-react";

export const ThemeToggle = () => {
  const { theme, toggle } = useTheme();
  return (
    <button
      data-testid="theme-toggle-button"
      onClick={toggle}
      aria-label="Toggle theme"
      className="p-2 rounded-full border bg-card hover:border-[var(--cc-accent)] transition-colors duration-200"
    >
      {theme === "dark" ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  );
};
